import type { ConversationNodeCallRecording } from 'lib-shared-types-api';

type RoutedThroughCallRecordingProps = {
  node: ConversationNodeCallRecording;
};

export function RoutedThroughCallRecording(
  _: RoutedThroughCallRecordingProps,
): JSX.Element {
  return <>Record conversation</>;
}
